class CartFreeSamples extends HHBaseElement {
  constructor() {
    super()

    this.$mainCart = this.closest('main-cart')
    this.$atcLabels = JSON.parse(window.atob(this.dataset.atcLabels))
    this.limits = Number(this.dataset.limits)
    this.$actions = this.querySelectorAll('.js-free-smaple-action')
    this._doFreeSample = this._doFreeSample.bind(this)
    this._addFreeSample = this._addFreeSample.bind(this)
    this._removeFreeSample = this._removeFreeSample.bind(this)
  }

  update(lineItem) {
    this.setAttribute('line-item-quantity', lineItem.quantity)
  }

  connectedCallback() {
    this._attachListeners()
    this.checkLimits()
    this._setAlly()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  checkLimits(cart = this.$mainCart?.cart) {
    if (this.limits === 0) return false
    const numfreeSamplesInCart = cart.items.reduce(
      (acc, cur) =>
        String(cur.properties['_free-sample']) === 'true' ? acc + 1 : acc,
      0
    )

    if (this.limits <= numfreeSamplesInCart) {
      this.querySelectorAll('.main-cart__free-sample:not(.added)').forEach(
        (item) => {
          item.querySelector('button').disabled = true
        }
      )
    } else {
      this.querySelectorAll('.main-cart__free-sample:not(.added)').forEach(
        (item) => {
          item.querySelector('button').disabled = false
        }
      )
    }
  }

  async _doFreeSample(item) {
    const sliderContainer = item.closest('swiper-container')
    if (sliderContainer) {
      sliderContainer.classList.add('processing')
    }

    const parent = item.closest('.main-cart__free-sample')
    if (parent.classList.contains('added')) {
      await this._removeFreeSample(item)
      item.querySelector('span').innerHTML = this.$atcLabels.add
      parent.classList.remove('added')
    } else {
      await this._addFreeSample(item)
      item.querySelector('span').innerHTML = this.$atcLabels.remove
      parent.classList.add('added')
    }
    this.triggerGlobalEvent('main-cart::refresh')
    this.checkLimits()
    if (sliderContainer) {
      sliderContainer.classList.remove('processing')
    }
  }

  async _addFreeSample(item) {
    const variant_id = Number(item.dataset.variantId)
    await window.__CART__CONTROLLER__.add(
      [
        {
          id: variant_id,
          quantity: 1,
          properties: {
            '_free-sample': true,
          },
        },
      ],
      true
    )
  }

  async _removeFreeSample(item) {
    const variant_id = Number(item.dataset.variantId)
    await window.__CART__CONTROLLER__.update({
      [variant_id]: 0,
    })
  }

  removedFromCart(key) {
    const sliderContainers = this.querySelectorAll('swiper-container')
    sliderContainers.forEach((item) => item.classList.add('processing'))
    const variant_id = key.split(':')[0]
    let hasMatchedItem = false
    this.$actions.forEach((item) => {
      if (item.dataset.variantId === variant_id) {
        item.querySelector('span').innerHTML = this.$atcLabels.add
        item.closest('.main-cart__free-sample').classList.remove('added')
        hasMatchedItem = true
      }
    })

    this.checkLimits()
    sliderContainers.forEach((item) => item.classList.remove('processing'))
  }

  handleCartRefreshed(e) {
    this.checkLimits(e.detail)
  }

  removedAllFromCart() {
    this.checkLimits()
  }

  _attachListeners() {
    this.$actions.forEach((item) => {
      item.addEventListener('click', (event) => this._doFreeSample(item))
    })

    document.addEventListener(
      'main-cart::refreshed',
      this.handleCartRefreshed.bind(this)
    )

    const swiperContainers = this.querySelectorAll('.js-swiper-container')

    swiperContainers.forEach((container) => {
      if (!container.shadowRoot) return

      const navButtons = [
        ...container.shadowRoot.querySelectorAll(
          '.swiper-button-prev, .swiper-button-next'
        ),
      ]

      navButtons.forEach((button) => {
        button.addEventListener('click', () => this._setAlly())
        button.addEventListener('keypress', () => this._setAlly())
      })
    })
  }

  _removeListeners() {
    this.$actions.forEach((item) => {
      item.removeEventListener('click', (event) => this._doFreeSample(item))
    })

    document.removeEventListener(
      'main-cart::refreshed',
      this.handleCartRefreshed.bind(this)
    )
  }

  _setAlly() {
    const swiperContainers = this.querySelectorAll('.js-swiper-container')

    swiperContainers.forEach((container) => {
      const containerWidth = container.offsetWidth

      let activeSlide = container.querySelector('.swiper-slide-active')

      if (container.classList.contains('js-swiper-mobile')) {
        const slideWrapper = container.querySelector('.swiper-slide-active')
        activeSlide = slideWrapper?.querySelector('swiper-slide')
      }

      if (!activeSlide) return

      const slideMargin = 14
      const leftMostSlideIndex = activeSlide.dataset.index
      const slideWidth = activeSlide.scrollWidth

      const calcNumOfVisibleSlides = Math.round(
        containerWidth / (slideWidth + slideMargin)
      )

      // Default to 3 for mobile, the slides are vertically stacked
      const numVisibleSlides =
        calcNumOfVisibleSlides === 1 ? 3 : calcNumOfVisibleSlides

      const slides = container.querySelectorAll('swiper-slide')
      const activeSlides = [...Array(slides.length).keys()]
        .slice(leftMostSlideIndex)
        .slice(0, numVisibleSlides)

      slides.forEach((slide) => {
        slide.setAttribute('aria-hidden', true)

        const button = slide.querySelector('button')
        button.setAttribute('tabindex', -1)

        const slideIndex = parseInt(slide.dataset.index)

        if (activeSlides.includes(slideIndex)) {
          slide.removeAttribute('aria-hidden')
          button.removeAttribute('tabindex')
        }
      })
    })
  }
}

window.customElements.define('cart-free-samples', CartFreeSamples)
